import state from '@/vuex/administracao/state.js'
import getters from '@/vuex/administracao/getters.js'
import mutations from '@/vuex/administracao/mutations.js'
import actions from '@/vuex/administracao/actions.js'

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default module
